import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-do-i',
  templateUrl: './how-do-i.component.html',
  styleUrls: ['./how-do-i.component.css']
})
export class HowDoIComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
